import styled from 'styled-components'

// SureCo Figma design tokens
const TEAL = '#00A5AD'
const TEAL_DARK = '#008a91'
const TEAL_BG = '#D4EDEE'
const TEXT_DARK = '#1A2B3C'
const TEXT_MUTED = '#9CA3AF'
const BORDER = '#D9E2EC'
const RADIUS = '0.625rem'
const FONT = "'Inter', ui-sans-serif, system-ui, sans-serif"

export const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-family: ${FONT};
`

export const PageSubtitle = styled.p`
  font-family: ${FONT};
  font-size: 15px;
  font-weight: 400;
  color: ${TEXT_MUTED};
  margin: -12px 0 0;
  line-height: 1.5;
`

export const FilterBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  background: #fff;
  border: 1px solid ${BORDER};
  border-radius: ${RADIUS};
  padding: 12px 16px;
`

export const FilterByLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: ${FONT};
  font-size: 11px;
  font-weight: 600;
  color: ${TEXT_MUTED};
  text-transform: uppercase;
  letter-spacing: 0.06em;
  white-space: nowrap;
  margin-right: 4px;
`

export const TableCard = styled.div`
  background: #fff;
  border-radius: ${RADIUS};
  border: 1px solid ${BORDER};
  overflow: hidden;
  font-family: ${FONT};

  .ant-table {
    font-family: ${FONT};
  }

  .ant-table-thead > tr > th {
    padding: 0 12px;
    height: 48px;
    font-family: ${FONT};
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    color: ${TEXT_DARK};
    background: #f0f4f8;
    border-bottom: 1px solid ${BORDER};
  }

  .ant-table-tbody > tr > td {
    padding: 12px;
    font-family: ${FONT};
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: ${TEXT_DARK};
    vertical-align: middle;
    border-bottom: 1px solid ${BORDER};
  }

  .ant-table-tbody > tr:last-child > td {
    border-bottom: none;
  }

  .ant-table-tbody > tr:hover > td {
    background: ${TEAL_BG}55 !important;
  }
`

export const TableFooter = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid ${BORDER};
  font-family: ${FONT};
  font-size: 12px;
  color: ${TEXT_MUTED};
  background: #fff;
  border-radius: 0 0 ${RADIUS} ${RADIUS};
`

export const PresetGroup = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`

export const PresetButton = styled.button<{ $active: boolean }>`
  font-family: ${FONT};
  font-size: 12px;
  font-weight: 500;
  padding: 4px 12px;
  border-radius: 999px;
  border: 1px solid ${({ $active }) => ($active ? TEAL : BORDER)};
  background: ${({ $active }) => ($active ? TEAL_BG : '#fff')};
  color: ${({ $active }) => ($active ? TEAL : TEXT_MUTED)};
  cursor: pointer;
  white-space: nowrap;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease;

  &:hover {
    border-color: ${TEAL};
    color: ${TEAL};
    background: ${TEAL_BG};
  }
`

export const DownloadLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 16px;
  font-family: ${FONT};
  font-size: 13px;
  font-weight: 500;
  border-radius: calc(${RADIUS} - 2px);
  border: 1px solid ${TEAL};
  background: ${TEAL};
  color: #ffffff;
  cursor: pointer;
  line-height: 1.5;
  white-space: nowrap;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  &:hover:not(:disabled) {
    background: ${TEAL_DARK};
    border-color: ${TEAL_DARK};
    box-shadow: 0 2px 6px ${TEAL}44;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }
`
